import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

export const DocumentScoringResultSummaryAlpha = ({ t, scoringResult }) => (
  <React.Fragment>
    <Grid container spacing={1}>
      <Grid item xs={12} sm={4}>
        <strong>{t('DocumentEdit.Scoring.ScoringResult.ScoringResult')}: </strong>
        <span>
          {scoringResult.hasScoringResult
            ? scoringResult.scoringResult || ''
            : t('DocumentEdit.Scoring.ScoringResult.ScoringResultNotApplicable')}
        </span>
      </Grid>
      <Grid item xs={12} sm={4}>
        <strong>{t('DocumentEdit.Scoring.ScoringResult.ScoringClassAlpha')}: </strong>
        <span>
          {scoringResult.hasScoringResult
            ? scoringResult.scoringClass || ''
            : t('DocumentEdit.Scoring.ScoringResult.ScoringResultNotApplicable')}
        </span>
      </Grid>
    </Grid>
  </React.Fragment>
);
DocumentScoringResultSummaryAlpha.propTypes = {
  t: PropTypes.func.isRequired,
  scoringResult: PropTypes.object.isRequired
};

export default withTranslation()(DocumentScoringResultSummaryAlpha);
